import { Table } from "antd";
import { forwardRef } from "react";
import { SimpleTableProps } from "./type";

function AntTableComp<T extends object>(
  props: SimpleTableProps<T>,
  ref?: React.ForwardedRef<HTMLDivElement>
) {
  return <Table<T> ref={ref as any} {...props} />;
}
const AntTable = forwardRef(AntTableComp) as <T extends object>(
  props: SimpleTableProps<T> & { ref?: React.ForwardedRef<HTMLDivElement> }
) => ReturnType<typeof AntTableComp>;
export { AntTable as SimpleTable };
